import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { MatDialogModule } from '@angular/material/dialog';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbGetAQuoteComponent } from './kb-get-aquote/kb-get-aquote.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { QuotePopupComponent } from './kb-get-aquote/quote-popup/quote-popup.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MediaModule } from '@spartacus/storefront';



@NgModule({
    declarations: [KbGetAQuoteComponent, QuotePopupComponent],
    imports: [
        CommonModule,
        RouterModule,
        I18nModule,
        MediaModule,
        UrlModule,
        MatDialogModule,
        MatExpansionModule,
        ReactiveFormsModule,
        ConfigModule.withConfig({
            cmsComponents: {
                MyQuoteEditFlexComponent: {
                    component: KbGetAQuoteComponent,
                    guards: [SecureGuard, AuthGuard]
                },
            }
        } as CmsConfig)
    ]
})
export class KbGetAQuote { }
